import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';

const COLORS = ["#152d51", "#154b51", "#8de546", "#2563EB", "#3B82F6", "#4F46E5", "#60A5FA", "#93C5FD", "#1E3A8A", "#0F172A"];

// Bar chart for infractions by driver
export const InfractionsByDriverChart = ({ data }) => (
  <ResponsiveContainer width="100%" height={250}>
    <BarChart data={data}>
      <XAxis dataKey="conductor" />
      <YAxis />
      <Tooltip />
      <Legend />
      <Bar dataKey="infracciones" fill="#3B82F6" radius={[8, 8, 0, 0]} />
    </BarChart>
  </ResponsiveContainer>
);

// Pie chart for infractions by type
export const InfractionsByTypeChart = ({ data }) => (
  <ResponsiveContainer width="100%" height={250}>
    <PieChart>
      <Pie
        data={data}
        dataKey="cantidad"
        nameKey="tipo"
        cx="50%"
        cy="50%"
        outerRadius="60%"
        label
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
        ))}
      </Pie>
      <Tooltip />
      <Legend />
    </PieChart>
  </ResponsiveContainer>
);

// Combined component (you can use either individual charts or this combined one)
const InfractionsChart = ({ data, type = 'driver' }) => {
  if (type === 'driver') {
    return <InfractionsByDriverChart data={data} />;
  }
  return <InfractionsByTypeChart data={data} />;
};

export default InfractionsChart;
